import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667m5.438 7.897a1.467 1.467 0 0 0-2.075 0L16 13.926l-3.363-3.362a1.465 1.465 0 1 0-2.073 2.073L13.926 16l-3.362 3.363a1.467 1.467 0 0 0 2.073 2.074L16 18.074l3.363 3.363a1.467 1.467 0 0 0 2.075-2.074L18.074 16l3.363-3.363c.573-.573.572-1.5 0-2.073" /></svg>;
export default SvgIconCrossRoundedFilledSmall;